import agent from './agent';
import role from './util/role';
import jwtDecode from 'jwt-decode';
import {
  ASYNC_START,
  ASYNC_END,
  LOGIN,
  LOGOUT,
  LOGIN_PAGE_VERIFY_PIN_CODE,
  VERIFY_USER_PIN
} from './constants/actionTypes';

const promiseMiddleware = store => next => action => {
  if (isPromise(action.payload)) {
    store.dispatch({ type: ASYNC_START, subtype: action.type });

    const currentView = store.getState().viewChangeCounter;
    const skipTracking = action.skipTracking;

    action.payload.then(
      res => {
        const currentState = store.getState()
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return
        }
        console.log('RESULT', res);
        action.payload = res;
        store.dispatch({ type: ASYNC_END, promise: action.payload });
        store.dispatch(action);
      },
      error => {
        const currentState = store.getState()
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return
        }
        console.log('ERROR', error);
        action.error = true;
        action.payload = error.response.data;
        if (!action.skipTracking) {
          store.dispatch({ type: ASYNC_END, promise: action.payload });
        }
        store.dispatch(action);
      }
    );

    return;
  }

  next(action);
};

const localStorageMiddleware = store => next => action => {
  if (
    action.type === LOGIN || 
    action.type === LOGIN_PAGE_VERIFY_PIN_CODE ||
    action.type === VERIFY_USER_PIN) {
    if (!action.error && action.payload.user && action.payload.user.token) {
      var decoded = jwtDecode(action.payload.user.token);
      if (!role.can(decoded.role, LOGIN)) {
        action.error = true;
        action.payload.error = { message: 'You are not authorized to login.' };
        store.dispatch({ type: ASYNC_END, promise: action.payload });
        store.dispatch(action);
        return
      } else {
        window.localStorage.setItem('badmin-jwt', action.payload.user.token);
        agent.setToken(action.payload.user.token);
      }
    }
  } else if (action.type === LOGOUT) {
    window.localStorage.setItem('badmin-jwt', '');
    agent.setToken(null);
  }

  next(action);
};

function isPromise(v) {
  return v && typeof v.then === 'function';
}


export { promiseMiddleware, localStorageMiddleware }



// WEBPACK FOOTER //
// ./src/middleware.js